module.exports = __webpack_public_path__ + "static/img/pad2.f3b60f6e.png";